var _style, _path, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgBancodechile = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 500 500",
    style: {
      enableBackground: "new 0 0 500 500"
    },
    xmlSpace: "preserve",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#173A79;}\r\n\t.st1{fill-rule:evenodd;clip-rule:evenodd;fill:#FFFFFF;}\r\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M430.5,500h-361C31.1,500,0,468.9,0,430.5v-361C0,31.1,31.1,0,69.5,0h361C468.9,0,500,31.1,500,69.5v361 C500,468.9,468.9,500,430.5,500z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "layer1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g1741"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1245",
    className: "st1",
    d: "M178,41h21.4c15.4,0,67.5,14.7,67.5,14.7h9c3.5,0,9.1-2.7,11.3-4.5c1.6,0.4,2.7,0.8,4.5,2.2 l-88.9,63.1c-0.1,0-27,13.4-27,25.9v158.9l-87.8,60.9c1.2-8.4,12.4-16.1,12.4-28.2V177.3c0-12.2,84.4-56.2,84.4-68.7 c0-12.4-49.5-22.5-49.5-22.5c-15.8-0.6-22.3-0.6-38.3,0c-15.7,0.6-33.3,10.5-39.4,10.2C76.6,83.5,127.2,41,178,41L178,41z  M358.1,44.4c13.5,0,21.7,14.5,45,45.1c5.8,7.5,32.6,40.5,32.6,56.3v12.4c0,32.1-84.4,64.4-84.4,77.8c0,9.1,44.4,4.8,64.2,18 c18.9,12.6,27,39.3,27,54.1v38.3c0,23.1-31.4,31.6-69.8,60.9C355.8,420,298.2,459,293.9,459c0,0-66.1-36-97.9-36h-42.8 c-18,0-61.9,15.8-65.3,15.8c0,0,66.3-65.4,134-65.4h45c9.3,0,41.2,13.1,49.5,15.8V103c0-2.8-3.6-7.9-9-7.9 c-12.5,0-21.4,22.8-21.4,23.7v170.1c0,7.7-29.3,30.3-45,39.4c-23.5,13.6-38.7,26.7-52.9,33.8v-3.4c0,0,12.4-13.5,12.4-21.4V152.5 c0-2.3,19.8-27,74.3-58.6C306.4,75.7,338.6,44.4,358.1,44.4L358.1,44.4z M332.2,255.1v138.6c0,6.8,12,12.4,19.1,12.4 c3.4,0-1.1,2.6,4.5,0V276.5C355.8,268,335.7,256,332.2,255.1L332.2,255.1z M332.2,122.1v101.4c22.2-13.3,36-20.3,36-38.3 C368.2,161.4,332.2,122.1,332.2,122.1L332.2,122.1z"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgBancodechile);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/BANCODECHILE.375bed36c0932e88920660e852db956d.svg";